import { AsyncSelectField } from 'components/Fields';
import { defaultFilters } from 'constants/filters';
import { useEffect } from 'react';

export const OptionSearchField = ({
  label,
  watch,
  field,
  control,
  setValue,
  optionsMap,
  requestUrl,
  responseKey,
  fieldProps = {},
}) => {
  const currentFieldValue = watch(field);

  useEffect(() => {
    if (!currentFieldValue) {
      const defaultFieldValue = defaultFilters.find(
        defaultFilter => defaultFilter.field === field
      )?.value;

      setValue(field, defaultFieldValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentFieldValue, field]);

  return (
    <AsyncSelectField
      name={field}
      menuPosition=""
      url={requestUrl}
      control={control}
      placeholder={label}
      optionsMap={optionsMap}
      responseKey={responseKey}
      {...fieldProps}
    />
  );
};
